<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-6 offset-md-3 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Contacto
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">
            <div class="row">
                <div class=" col-12 col-md-6 offset-md-3">
                    <app-search-client (close)="closeAddClient()"></app-search-client>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- ══════════════════════════════════════════════════════════════════════════
     CONTACTOS — la lista.

     🔴 REDISEÑO 2026-09-21. Juan, mirando la pantalla: *«mira cómo se ven esas
     listas gigantes. Dios mío»*.

     Lo que pasaba, medido: cada persona era una TARJETA de 118 px (avatar de
     62 px + 40 px de relleno + 16 px de separación). Cincuenta resultados eran
     5.900 px de scroll para leer cincuenta nombres y cincuenta cédulas — y la
     lista es de 1,9 millones de personas, así que cincuenta no es el caso
     grande: es el más chico.

     Ahora es la tabla de la casa (`kb-table`), el mismo molde de Comercios:
     44 px por fila, 2.200 px para los mismos cincuenta. El avatar se queda
     —sirve para reconocer a alguien de un vistazo— pero en 32 px, dentro de la
     celda del nombre, que es a lo que pertenece.

     🔴 NO SE TOCÓ NADA DEL COMPONENTE: `getPeople`, `nextRows`, `onScrollDown`,
     `getIdentity`, `usersActives` y el `infiniteScroll` son los mismos. Esto es
     la plantilla y su hoja de estilos.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="kb-page">

  <!-- ══ Encabezado ═══════════════════════════════════════════════════════════ -->
  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title flex items-center gap-2">
        <i class="fas fa-users text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Contactos
      </h1>
      <p class="kb-page-meta">
        Busca una persona por su nombre o su apellido y abre su perfil.
      </p>
    </div>
  </div>

  <!-- ══ El buscador, en su tarjeta ═══════════════════════════════════════════ -->
  <section class="kb-tarjeta">
    <div class="flex flex-col gap-4 px-6 sm:flex-row sm:items-end">
      <div class="min-w-0 flex-1 space-y-1.5">
        <label class="kb-campo-et" for="buscarContacto">Buscar una persona</label>
        <div class="kb-buscador">
          <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
          <input id="buscarContacto" type="text" class="kb-input kb-input-icono w-full"
                 placeholder="Nombre o apellido"
                 [(ngModel)]="search_form" (keyup.enter)="getPeople(true)">
        </div>
      </div>
      <button type="button" class="kb-btn kb-btn-primary shrink-0"
              (click)="getPeople(true)" [disabled]="submit_disabled">
        <i class="fas" [ngClass]="submit_disabled ? 'fa-spinner fa-spin' : 'fa-search'" aria-hidden="true"></i>
        {{ submit_disabled ? 'Buscando…' : 'Buscar' }}
      </button>
    </div>
  </section>

  <!-- ══ Los resultados ═══════════════════════════════════════════════════════ -->
  <section class="kb-tarjeta" *ngIf="people">
    <div class="kb-tarjeta-cab">
      <div class="space-y-1">
        <h2 class="text-base font-semibold leading-none">
          <span class="tabular-nums">{{ rows.length }}</span>
          de <span class="tabular-nums">{{ people_total | number }}</span>
          {{ people_total === 1 ? 'persona' : 'personas' }}
        </h2>
        <p class="text-sm text-muted-foreground">
          La fila entera abre el perfil. Al llegar al final se cargan más solas.
        </p>
      </div>
    </div>

    <div class="kb-tarjeta-cuerpo">
      <div class="kb-tabla-plana" infiniteScroll
           [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="2"
           [infiniteScrollThrottle]="50"
           (scrolled)="onScrollDown()" (scrolledUp)="onScrollUp()">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Persona</th>
              <th class="kb-th">Identificación</th>
              <th class="kb-th">Ejecutivo</th>
              <th class="kb-th">Se registró</th>
              <th class="kb-th kb-th-acciones">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr class="kb-tr kb-tr-clic last:border-b-0" *ngFor="let item of rows; let i = index"
                [routerLink]="['/console/person/profile/', item?.person?.code]">

              <td class="kb-td">
                <div class="flex items-center gap-3">
                  <!-- 32 px y no 62. El punto verde de «conectado» se queda: es
                       el único dato de la fila que cambia solo. -->
                  <span class="ct-avatar" [class.ct-avatar-activo]="usersActives[item?.person?.code]"
                        [style.background-image]="'url(' + (item?.person?.file_selfie?.url || 'assets/public/images/avatar.png') + ')'"
                        aria-hidden="true"></span>
                  <span class="kb-td-titulo capitalize">
                    {{ item?.person?.name }} {{ item?.person?.lastName }}
                  </span>
                </div>
              </td>

              <td class="kb-td kb-td-mono">{{ getIdentity(item) }}</td>

              <td class="kb-td">
                <span *ngIf="item?.person?.ejecutive">{{ item?.person?.ejecutive?.name }} {{ item?.person?.ejecutive?.lastName }}</span>
                <span class="text-muted-foreground" *ngIf="!item?.person?.ejecutive">—</span>
              </td>

              <td class="kb-td whitespace-nowrap">
                {{ item?.person?.date | date: 'dd/MM/yyyy' }}
                <span class="text-xs text-muted-foreground">{{ item?.person?.date | date: 'h:mm a' }}</span>
              </td>

              <td class="kb-td-acciones" (click)="$event.stopPropagation()">
                <a class="kb-btn kb-btn-ghost kb-btn-sm"
                   [routerLink]="['/console/person/profile/', item?.person?.code]">
                  Ver perfil<i class="fas fa-arrow-right" aria-hidden="true"></i>
                </a>
              </td>
            </tr>

            <!-- Vacío -->
            <tr *ngIf="!loading && rows.length < 1">
              <td colspan="5">
                <div class="kb-empty">
                  <span class="kb-empty-icono"><i class="fas fa-users" aria-hidden="true"></i></span>
                  <p class="kb-empty-titulo">No se encontró ninguna persona</p>
                  <p class="kb-empty-texto">
                    Prueba con otro nombre o comprueba cómo está escrito el apellido.
                  </p>
                </div>
              </td>
            </tr>

            <!-- Cargando -->
            <tr *ngIf="loading">
              <td colspan="5">
                <div class="space-y-3 py-2">
                  <div class="kb-skeleton h-4 w-full" *ngFor="let s of [1,2,3,4,5]"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-center pt-1" *ngIf="!loading && rows.length > 0">
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="nextRows()">
          <i class="fas fa-chevron-down" aria-hidden="true"></i>Cargar más contactos
        </button>
      </div>
    </div>
  </section>
</div>
